import styled from 'styled-components'
import { media } from '../../../styles/utils'

export const Container = styled.div`
  display: flex;
  width: 100%;
  margin: 14px auto 30px;

  ${media.sm`
    padding: 0 4px;
  `};
`
